import { render, staticRenderFns } from "./ThreatsHttpStatusPie.vue?vue&type=template&id=2a93a94b"
import script from "./ThreatsHttpStatusPie.vue?vue&type=script&lang=js"
export * from "./ThreatsHttpStatusPie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports